import ListIcon from '@material-ui/icons/List';

import List from './List2';

export default {
  list: List,
  icon: ListIcon,
};
